// extracted by mini-css-extract-plugin
export default {"container":"RangeSlider_container__uXw8S","slider":"RangeSlider_slider__UXjLj"};